<button
  pButton
  type="button"
  icon="fas fa-trash"
  [label]="'COMMON.DELETE' | translate"
  size="small"
  class="p-button-sm p-button-outlined p-button-danger"
  (click)="execute()"
></button>
